import SocketHelper from "../helpers/socket";
import ApiClient from "./ApiClient";
export const login = async (phone, password, onSuccess, onError) => {
    try {
        const params = { 'login': phone, 'password': password };
        const response = await ApiClient.post('/login', params);
        if (response.status == 200 || response.status == 201) {
            if (onSuccess != null) onSuccess(response.data.data);
        }
    } catch (error) {
        if (onError != null) onError(error);
    }
};
export const loginGoogle = async (gmail, name, uid, onSuccess, onError) => {
    try {
        const params = {
            "id_token": uid,
            "email": gmail,
            "name": name,
            "provider": "firebase"
          };
        const response = await ApiClient.post('/firebase-auth', params);
        if (response.status == 200 || response.status == 201) {
            if (onSuccess != null) onSuccess(response.data.data);
        }
    } catch (error) {
        if (onError != null) onError(error);
    }
};
export const register = async (params, onSuccess = null, onError = null) => {
    await ApiClient.post('/register', params).then(response => {
        if (response.status == 200 || response.status == 201) {
            if (onSuccess != null) onSuccess(response.data.data);
        }
    }).catch(error => {
        if (onError != null) onError(error);
    });
};
export const passwordChange = async (params, onSuccess = null, onError = null) => {
    console.log('params', params);
    await ApiClient.post('/user/change/password', params).then(response => {
        if (response.status == 200 || response.status == 201) {
            if (onSuccess != null) onSuccess(response.data.data);
        }
    }).catch(error => {
        if (onError != null) onError(error);
    });
};
export const userDetails = async (params) => {
    try {
        const response = await ApiClient.get('/user', params);
        if (response.status == 200 || response.status == 201) {
            return response.data.data;
        }
    } catch (error) {
        console.log('fetch user details error ', error.response);
    }
    return null;
};
export const checkPhone = async (phone) => {
    try {
        const response = await ApiClient.get('/user/check', { 'email': phone });
        if (response.status == 200 || response.status == 201) {
            return true;
        }
    } catch (error) {
        return false;
    }
};
export const sendEmailVerification = async (email) => {
    try {
        const response = await ApiClient.post('/user/send-code', { 'email': email });
        if (response.status == 200 || response.status == 201) {
            return true;
        }
    } catch (error) {
        return false;
    }
};
export const verifyEmail = async (email, code) => {
    try {
        const response = await ApiClient.post('/user/verify-code', { 'email': email, 'code': code });
        if (response.status == 200 || response.status == 201) {
            return true;
        }
    } catch (error) {
        return false;
    }
}
// export const changePassword = async (password) => {
    
// }
export const deleteAd = async (id) => {
    try {
        const response = await ApiClient.delete('/products/' + id);
        if (response.status == 200 || response.status == 201) {
            return response.data.data;
        }
    } catch (error) {
        console.log('Error', error.response);
    }
    return null;
};
export const userSettings = async (params, onSuccess = null, onError = null) => {
    await ApiClient.post('/user', params, 'multipart/form-data').then(response => {
        if (response.status == 200 || response.status == 201) {
            if (onSuccess != null) onSuccess(response.data.data);
        }
    }).catch(error => {
        if (onError != null) onError(error);
    });
};
export const getUserChats = async () => {
    try {
        const response = await ApiClient.get('/chats');
        if (response.status == 200 || response.status == 201) {
            return response.data.data;
        }
    } catch (error) {
        console.log('fetch user details error ', error.response);
    }
    return null;
}
export const getUserMessages = async (params) => {
    try {
        const response = await ApiClient.get('/messages', params);
        if (response.status == 200 || response.status == 201) {
            return response.data.data;
        }
    } catch (error) {
        console.log('fetch user details error ', error.response);
    }
    return null;
}
export const postUserMessage = async (params) => {
    try {
        SocketHelper.getInstance().sendMessage(params['message']);
        const response = await ApiClient.post('/messages', params);
        if (response.status == 200 || response.status == 201) {
            return response.data.data;
        }
    } catch (error) {
        console.log('fetch user details error ', error.response);
    }

    return null;
}

export const fetchChatByPartner = async (partnerId) => {
    try {
        const response = await ApiClient.get('/chats', { 'partner_id': partnerId });
        if (response.status == 200 || response.status == 201) {
            const data = response.data.data;
            if (data.length > 0) {
                return data[0];
            }
        }
    } catch (error) {
        console.log('fetch user details error ', error.response);
    }
    return null;
}
export const readMessages = async (params) => {
    try {
        const response = await ApiClient.post('/messages/read', params);
        if (response.status == 200 || response.status == 201) {
            return response.data.data;
        }
    } catch (error) {
        console.log('fetch user details error ', error.response);
    }
    return null;
}
export const deleteChat = async (id) => {
    try {
        const response = await ApiClient.delete('/messages/' + id);
        if (response.status == 200 || response.status == 201) {
            return response.data.data;
        }
    } catch (error) {
        console.log('fetch user details error ', error.response);
    }
    return null;
}
export const unreadMessages = async () => {
    try {
        const response = await ApiClient.get('/messages/unread-count');
        if (response.status == 200 || response.status == 201) {
            return response.data.data;
        }
    } catch (error) {
        console.log('fetch user details error ', error.response);
    }
    return null;
}
export const depositAmount = async (params) => {
    try {
        const response = await ApiClient.post('/user/create-payment', params);
        if (response.status == 200 || response.status == 201) {
            return response.data.data;
        }
    } catch (error) {
        console.log('fetch user details error ', error.response);
    }
    return null;
}